module.exports = {
  // pathPrefix: '/interactives/2018/may/state-scorecard', // CMWF
  // pathPrefix: '/2018/state-scorecard', // CMWF - S3
  // pathPrefix: '/interactives/2018/may/test/state-scorecard', // CMWF Test
  pathPrefix: '/', // Local and Netlify

  siteTitle: 'Scorecard on State Health System Performance', // Navigation and Site Title
  siteSubtitle: 'Scorecard on State Health System Performance', // Navigation and Site Title
  siteYear: '2019', //
  siteTitleAlt: 'The Commonwealth Fund - 2019 Scorecard on State Health System Performance', // Alternative Site title for SEO
  siteUrl: 'https://cmwf-2019-scorecard.netlify.app', // Netlify - Domain of your site. No trailing slash!
  // siteUrl: 'http://www.commonwealthfund.org', // CMWF - Domain of your site. No trailing slash!
  // siteUrl: 'https://interactives.commonwealthfund.org', // S3 - Domain of your site. No trailing slash!
  siteLanguage: 'en', // Language Tag on <html> element
  siteLogo: '/logos/logo-cmwf.png', // Used for SEO and manifest
  siteDescription: 'A state-by-state report measuring access to care, quality of care, health outcomes, and health disparities across the United States.',

  siteFBAppID: '', // Facebook App ID
  userTwitter: '', // Twitter Username
  ogSiteName: '', // Facebook Site Name
  googleAnalyticsID: '', // Google Analytics ID

  // Date format used in your project
  // More information here: https://date-fns.org/v1.29.0/docs/format
  dateFormat: 'DD/MM/YYYY',

  // Settings for typography.js
  headerFontFamily: 'Berlingske Serif Text',
  bodyFontFamily: 'Berlingske Serif Text',
  baseFontSize: '20px',
};



// WEBPACK FOOTER //
// ./config/SiteConfig.js